// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".url-ellipsis[data-v-bd9e5a38]{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:250px;display:inline-block}.button_actions[data-v-bd9e5a38]{position:sticky;z-index:22;bottom:10px}", ""]);
// Exports
module.exports = exports;
